import Row from 'antd/es/row'
import { convertPxToNumber } from '../../../../utils/helpers.ts'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import Col from 'antd/es/grid/col'
import IdeyaTypography from '../../../../common/antd/ideya-typography.tsx'

interface IdeaCardExtraRowProps {
  label1: string
  label2: string
  value1: string
  value2: string
  style1?: React.CSSProperties
  style2?: React.CSSProperties
}

export const IdeaExtraRow: React.FC<IdeaCardExtraRowProps> = ({
  label1,
  value1,
  style1,
  label2,
  value2,
  style2,
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  return (
    <Row
      gutter={[
        convertPxToNumber(themeStyle.marginMD),
        convertPxToNumber(themeStyle.marginMD),
      ]}
    >
      <Col span={12}>
        <Row>
          <IdeyaTypography.Text size={'xs'} type={'secondary'}>
            {label1}
          </IdeyaTypography.Text>
        </Row>
        <Row>
          <IdeyaTypography.Text style={style1}>{value1}</IdeyaTypography.Text>
        </Row>
      </Col>
      <Col span={12}>
        <Row>
          <IdeyaTypography.Text size={'xs'} type={'secondary'}>
            {label2}
          </IdeyaTypography.Text>
        </Row>
        <Row>
          <IdeyaTypography.Text style={style2}>{value2}</IdeyaTypography.Text>
        </Row>
      </Col>
    </Row>
  )
}
